import React from 'react';
import styles from './Realestatedemo.module.css';
import Navbar from './Navbar';
import BookingSection from './BookingSection';
import MatrixBackground from './MatrixBackground';

const realEstateFormConfig = {
  source: "Real Estate Page",
  labels: {
    business: "Brokerage or Agent Name",
    website: "Website or Zillow Profile",
    industry: "Focus (Residential, Luxury, Investment)",
    revenue: "Monthly Closings / GCI (Optional)",
    painPoint: "What’s your #1 pipeline or follow-up challenge?",
    dream: "How many closings/month would change everything?",
    lifeChange: "What would hitting your real goals unlock for you?"
  },
  helpAreas: [
    "Lead generation",
    "Lead qualification + follow-up",
    "CRM / Pipeline management",
    "Client nurturing (texts/emails)",
    "Showing + appointment automation",
    "Content / Video marketing",
    "Social media growth",
    "Transaction + doc automation",
    "Review / Referral systems"
  ]
};

const steps = [
  {
    title: "1. Instant Lead Capture & Logging",
    desc: "Prospects fill out a branded form. Their data is instantly logged, cleaned, and classified into your CRM or Google Sheet.",
  },
  {
    title: "2. AI Qualification Engine",
    desc: "Leads are automatically segmented by budget, income, and intent — using GPT to prioritize who matters most.",
  },
  {
    title: "3. Smart Matching & Estimates",
    desc: "Our system auto-matches each lead with 3 ideal properties and calculates estimated mortgage payments instantly.",
  },
  {
    title: "4. Automated Follow-Up & Nurture",
    desc: "Whether it’s 2 PM or 2 AM, leads receive personalized SMS/email follow-ups, questions answered by AI on autopilot.",
  },
  {
    title: "5. Real-Time Agent Alerts",
    desc: "High-value leads ping your phone or inbox automatically, including property matches, contact info, and next steps.",
  },
  {
    title: "6. Offer-Ready. Referral-Ready.",
    desc: "We even help draft offer docs, handle counter-offers, and circle back after closing for reviews, testimonials, and referrals.",
  },
];

export default function Realestatedemo() {
  return (
    
    <div className={styles.pageBackground}>
      <MatrixBackground />
      <Navbar />

      <section className={styles.heroIntro}>
        <h1 className={styles.heroTitle}>Automate Your Flow</h1>
      </section>

      <section className={styles.roiStrip}>
        <p>
          🧠 Agents save <strong>60+ hrs/month</strong> and unlock an estimated <strong>$3,500/mo ROI</strong> using our AI systems.
        </p>
      </section>

      <section id="how-it-works" className={styles.howItWorksSection}>
        <h2 className={styles.title}>How It Works for Real Estate Agents</h2>
        <div className={styles.stepsGrid}>
          {steps.map((step, idx) => (
            <div key={idx} className={styles.stepCard}>
              <div className={styles.stepNumber}>{step.title}</div>
              <div className={styles.stepDesc}>{step.desc}</div>
            </div>
          ))}
        </div>
        <button
          className={styles.ctaButton}
          onClick={() => document.getElementById('book')?.scrollIntoView({ behavior: 'smooth' })}
        >
          Ready to automate your agency?
        </button>
      </section>

      <div className={styles.sectionDivider}>
        <span>Let’s Design Your Stack</span>
      </div>

      <BookingSection config={realEstateFormConfig} />
    </div>
  );
}
